export const navItems = [
	{
		name: "Home",
		link: "#home",
	},
	{
		name: "About",
		link: "#about",
	},
	{
		name: "Services",
		link: "#services",
	},
	{
		name: "Portfolio",
		link: "#portfolio",
	},
	{
		name: "Contact",
		link: "#contact",
	}
];


// WEBPACK FOOTER //
// ./src/config/nav.js